import { createSlice } from "@reduxjs/toolkit";
import { createSelector } from "reselect";
import { createAction } from "@reduxjs/toolkit";
import { apiCallBegan } from "./api";

const slice = createSlice({
  name: "paymentManagement",
  initialState: {
    isPaymentProviderModalOpen: false,
    isAddingProvider: false,
    isAddedProvider: false,
    paymentProviderList: [],
    paymentOptionProviderList: [],
    provideraddedMessage: {},
    paymentProvider: {},
  },

  reducers: {
    // GET Request

    paymentProviderModalOpened: (paymentManagement, action) => {
      paymentManagement.isPaymentProviderModalOpen = true;
    },
    paymentProviderModalClosed: (paymentManagement, action) => {
      paymentManagement.isPaymentProviderModalOpen = false;
    },
    addedNewProvider: (paymentManagement, action) => {
      paymentManagement.isAddingProvider = false;
      paymentManagement.isAddedProvider = true;
      paymentManagement.provideraddedMessage = action.payload;
    },
    addingNewProvider: (paymentManagement, action) => {
      paymentManagement.isAddingProvider = true;
    },
    allPaymentProviderSuccess: (paymentManagement, action) => {
      paymentManagement.paymentProviderList =
        action.payload?.paymentMethodTypesDetails;
    },
    allPaymentOptionProviderSuccess: (paymentManagement, action) => {
      paymentManagement.paymentOptionProviderList =
        action.payload?.paymentMethodTypesDetails;
    },
    updatePaymentProvider: (paymentManagement, action) => {
      paymentManagement.paymentProvider = action.payload;
    },
    paymentProviderNull: (paymentManagement, action) => {
      paymentManagement.paymentProvider = {};
    },
  },
});

export const {
  paymentProviderNull,
  paymentProviderModalOpened,
  paymentProviderModalClosed,
  addingNewProvider,
  addedNewProvider,
  allPaymentProviderSuccess,
  allPaymentOptionProviderSuccess,
  updatePaymentProvider,
} = slice.actions;

export default slice.reducer;

// action creator

export const getAllPaymentProvider = () =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/custom-payment-method",
    method: "get",
    onSuccess: allPaymentProviderSuccess.type,
  });

export const getAllPaymentOptionProvider = () =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/custom-payment-method/getPaymentOption",
    method: "get",
    onSuccess: allPaymentOptionProviderSuccess.type,
  });

export const addNewPaymentProvider = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/custom-payment-method",
    method: "post",
    data: data,
    onStart: addingNewProvider.type,
    onSuccess: addedNewProvider.type,
  });

export const getPaymentModalOpen = createSelector(
  (state) => state.entities.paymentManagement,
  (paymentManagement) => paymentManagement.isPaymentProviderModalOpen
);
export const createPaymentProvider = createSelector(
  (state) => state.entities.paymentManagement,
  (paymentManagement) => paymentManagement.onSuccessMessage
);

export const getPaymentProviders = createSelector(
  (state) => state.entities.paymentManagement,
  (paymentManagement) => paymentManagement.paymentProviderList
);

export const getPaymentOptionProviders = createSelector(
  (state) => state.entities.paymentManagement,
  (paymentManagement) => paymentManagement.paymentOptionProviderList
);
export const getUpdateProvider = createSelector(
  (state) => state.entities.paymentManagement,
  (paymentManagement) => paymentManagement.paymentProvider
);
export const getIsAddedProvider = createSelector(
  (state) => state.entities.paymentManagement,
  (paymentManagement) => paymentManagement.isAddedProvider
);
export const getAddUpdateResp = createSelector(
  (state) => state.entities.paymentManagement,
  (paymentManagement) => paymentManagement.provideraddedMessage
);
